/**
 * SageMaker API Service
 *
 * Service functions for interacting with the SageMaker / CloudWatch integration endpoints.
 */

import { apiClient } from "./api";
import type {
  SageMakerConnectionCreate,
  SageMakerConnectionRead,
  SageMakerSetupInstructions,
  SageMakerSyncResult,
  PaginatedSageMakerConnections,
} from "@/types/sagemaker";

const API_PREFIX = "/api/v1/sagemaker";

export async function getSageMakerSetupInstructions(): Promise<SageMakerSetupInstructions> {
  return apiClient.get<SageMakerSetupInstructions>(`${API_PREFIX}/connections/setup`);
}

export async function listSageMakerConnections(
  page: number = 1,
  itemsPerPage: number = 10
): Promise<PaginatedSageMakerConnections> {
  const params = new URLSearchParams({
    page: page.toString(),
    items_per_page: itemsPerPage.toString(),
  });
  return apiClient.get<PaginatedSageMakerConnections>(
    `${API_PREFIX}/connections?${params.toString()}`
  );
}

export async function createSageMakerConnection(
  data: SageMakerConnectionCreate
): Promise<SageMakerConnectionRead> {
  return apiClient.post<SageMakerConnectionRead>(`${API_PREFIX}/connections`, data);
}

export async function deleteSageMakerConnection(connectionId: number): Promise<void> {
  return apiClient.delete(`${API_PREFIX}/connections/${connectionId}`);
}

export async function syncSageMakerConnection(connectionId: number): Promise<SageMakerSyncResult> {
  return apiClient.post<SageMakerSyncResult>(
    `${API_PREFIX}/connections/${connectionId}/sync`,
    {}
  );
}
